import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";
import {Dialog, Icon, Toast} from "vant";
import touch from "vue-directive-touch";
import {getUrlParam} from "@/utils/tool";
import {wxBaseUrl} from "@/config"
import VueAMap from "vue-amap";
import request from 'cmn-utils/lib/request';
import config from './config';
import $$ from 'cmn-utils'
import {isWechat} from "./utils/tool"
import pluginHttp from "./plugin/http"
import pluginDefault from "./plugin/default"
import pluginDICT from "./plugin/dict"
import PermissionsFilter from "./components/PermissionsFilter"
import Layout from "./components-show/Layout"
import TreeMenu from "./components/TreeMenu"

Vue.config.productionTip = false

Vue.use(Dialog);
Vue.use(VueAMap);
Vue.use(Icon);
Vue.use(touch);
Vue.use(require("vue-wechat-title"));
Vue.use(pluginHttp);
Vue.use(pluginDefault);
Vue.use(pluginDICT);
Vue.component(PermissionsFilter.name, PermissionsFilter)
Vue.component(TreeMenu.name, TreeMenu)
Vue.component(Layout.name, Layout)

VueAMap.initAMapApiLoader({
    key: "c476d88bfbd6da0f144b83c8c6e22520",
    plugin: [
        "AMap.Autocomplete",
        "AMap.PlaceSearch",
        "AMap.Scale",
        "AMap.OverView",
        "AMap.ToolBar",
        "AMap.MapType",
        "AMap.PolyEditor",
        "AMap.CircleEditor",
        "AMap.Geolocation",
        "AMap.Geocoder"
    ],
    v: "1.4.4"
});

request.config(config.request);
if (isWechat()) {
    if (!$$.oldGet) {
        $$.oldGet = $$.get
    }
    if (!$$.oldPost) {
        $$.oldPost = $$.post
    }
    $$.get = (url, data, config = {}) => {
        if (!url.startsWith('http')) url = wxBaseUrl + '/api/wechat/get?url=' + url
        return $$.oldGet(url, data, config)
    }
    $$.post = (url, data, config = {}) => {
        if (!url.startsWith('http')) url = wxBaseUrl + '/api/wechat/post?url=' + url
        return $$.oldPost(url, data,)
    }
}


const code = getUrlParam("code");

function go({to, from, next}) {
    const openId = store.getters['wechat/openId'];
    const SDK = store.getters['wechat/SDK'];
    if (openId) {
        !SDK && store.dispatch({type: 'wechat/getSDK'})
        store.dispatch({type: 'global/login', payload: {to, next}})
    } else {
        if (code) {
            store.dispatch({type: 'wechat/getOpenId', payload: {to, from, next, router, code}})
        } else {
            store.dispatch({
                type: 'wechat/auth',
                payload: {next, router}
            })
        }
    }
}

router.beforeEach((to, from, next) => {
    if (isWechat()) {
        const appId = store.getters['wechat/appId'];
        if (!appId) {
            store.dispatch({type: 'wechat/getAppId'}).then(bo => {
                if (bo) go({to, from, next})
                else Toast.fail('获取appId失败，请联系管理员');
            })
        } else {
            go({to, from, next})
        }

    } else {
        store.dispatch({type: 'global/login', payload: {to, next}});
    }
});
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
